// components/ui/Typography.tsx
import { Typography as MUITypography, TypographyProps } from '@mui/material';

const Typography = (props: TypographyProps) => {
  return <MUITypography {...props} />;
};

export default Typography;
